import { util } from 'pevueglobal'
import { setXVtableMutations } from '../XVtableV2'
import { graphdata, getGraphUrl, setReportStatus, resetreportstatus, setGraphdata } from '../XVgraphcontrol.js'
import locStore from 'store2'
import { store } from '@/store/'

// state
const state = () => ({
  activityTable: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: [],
  },
  categorielist: [],
  labels: [],
  settings: [],
  graphdata: [],
  activitySettings: {
    selallCatMobileSelected: true,
    sortKey: '',
    zoekDatumVan: null,
    zoekDatumTot: null,
    ienddate: null,
    istartdate: null,
    multiselected: [],
    multiselectedfilter: [],
    btnToevoegenSetting: false,
    delenActiviteit: false,
    delenActiviteitXVtableshow: false,
    overzichtActiviteit: true,
    shareSelected: [],
    toggleSelectAllValue: false,
    tableview: [],
    btnExcelDisabled: false,
    btnPDFDisabled: false,
    lstore: null,
    btnwis: false,
    paging: true,
    pdfdownloaddata: undefined,
    exceldownloaddata: undefined,
    delenTableSettings: undefined,
    hasMobile: false,
    firstItemCatlist: '',
    tbxOmschrijving: '',
    zoekTbxOmschrijving: '',
    tbxOmschrijvingVisible: false,
    dateToday: '',
  },
  waiter: true,
})

// getters
const getters = {
  activityTable: (state) => state.activityTable,
  categorielist: (state) => state.categorielist,
  labels: (state) => state.labels,
  settings: (state) => state.settings,
  graphdata: graphdata('graphdata'),
  waiter: (state) => state.waiter,
}

// actions
const actions = {
  getTexten: async ({ dispatch }) => {
    let textIDs = [
      53,
      56,
      96,
      20432,
      165,
      334,
      2258,
      2260,
      2267,
      2276,
      5494,
      8835,
      8893,
      8915,
      9162,
      10367,
      12339,
      14377,
      14449,
      14450,
      14451,
      14452,
      14453,
      14454,
      14455,
      14456,
      14463,
      14508,
      14638,
      14639,
      15450,
      15987,
      19579
    ]
    dispatch('gettranslations', textIDs, { root: true })
  },
  getGraphUrl: getGraphUrl('setReportStatus'),
  getactivity: async ({ commit, state, rootState }, { role, tblpersonid, boolPopupModus }) => {
    if (role === 'beheer') {
      const graphInput = {
        pagename: 'SPE021_BH_PEActiviteiten.aspx',
        clientid: '',
      }
      // Als het een popup is dan geen graph tonen en pagename leeg maken
      if (boolPopupModus === 1) {
        graphInput.pagename = ''
      }

      // haal eerst pagina data op en daarna pas tabel en graphcontrol
      util
        .getDataApi('beheer/PEapi_SPE021_BH_PEActiviteiten', {
          tblpersonid: tblpersonid,
          boolPopupModus: boolPopupModus,
        })
        .then(async (actdata) => {
          const data = {
            actdata,
            firstItemCatlist: rootState.translation[14456],
            role: role,
          }
          commit('setactivity', data)
        })
      let [graphdata, acttabledata] = await Promise.all([
        util.getDataApi('allroles/PEapi_GraphControl_Get_Available_Graphs', graphInput),
        util.GetXVTableDataV2('beheer/PEapi_SPE021_BH_PEActiviteiten_XVTable', {
          tblpersonid: tblpersonid,
          boolPopupModus: boolPopupModus,
        }),
      ])
      commit('setGraphdata', graphdata)

      acttabledata.tabledata.forEach((row) => {
        util.FormatStringDecimal(parseFloat(row.tblPersonPEActivityPEPoints).toLocaleString(util.GetCulture()))
      })
      commit('setActivityTableData', acttabledata)
      commit('setXVtableColumnsettingsBeheer')
      commit('setXVtablesettingBeheer')

      commit('initXVtableState', state.activityTable)
      commit('setOmschrijving', state.activityTable)
    } else {
      const graphInput = {
        pagename: 'SPE021_PR_PEActiviteiten.aspx',
        clientid: '',
      }
      // haal eerst pagina data op en daarna pas tabel en graphcontrol
      util.getDataApi('prof/PEapi_SPE021_PR_PEActiviteiten').then(async (actdata) => {
        const data = {
          actdata,
          firstItemCatlist: rootState.translation[14456],
          role: role,
        }
        commit('setactivity', data)
      })

      let [graphdata, acttabledata] = await Promise.all([
        util.getDataApi('allroles/PEapi_GraphControl_Get_Available_Graphs', graphInput),
        util.GetXVTableDataV2('prof/PEapi_SPE021_PR_PEActiviteiten_XVTable'),
      ])
      commit('setGraphdata', graphdata)

      acttabledata.tabledata.forEach((row) => {
        util.FormatStringDecimal(parseFloat(row.tblPersonPEActivityPEPoints).toLocaleString(util.GetCulture()))
      })
      commit('setActivityTableData', acttabledata)
      commit('setXVtableColumnsettings')
      commit('setXVtablesetting')

      commit('initXVtableState', state.activityTable)
      commit('setOmschrijving', state.activityTable)
    }
    commit('stopLoading', null, { root: true })
    commit('setWaiter', false)
  },
}

// mutations
const mutations = {
  setReportStatus: setReportStatus('graphdata'),
  resetreportstatus: resetreportstatus('graphdata'),
  setGraphdata: setGraphdata('graphdata'),

  ...setXVtableMutations('activityTable'),
  setWaiter(state, bool) {
    state.waiter = bool
  },
  setOmschrijving(state, table) {
    let countrows = false
    // check of tblPersonPEActivityDescription gevuld is
    table.tabledata.forEach((datarow) => {
      if (datarow.tblPersonPEActivityDescription !== null) {
        countrows = true
        state.activitySettings.tbxOmschrijvingVisible = true
      }
    })
    if (countrows === false) {
      // Geen waardes gevonden dus column op invisible. Waarde 0 (false)
      state.activityTable.tablecolumnsetting.forEach((row, index) => {
        if (row.tblPEapiProcTableColumnName === 'tblPersonPEActivityDescription') {
          row.tblPEapiProcTableColumnVisible = 0
        }
      })
    } else {
      // Wel een waarde gevonden dus column op visible. Waarde 1 (true)
      state.activityTable.tablecolumnsetting.forEach((row, index) => {
        if (row.tblPEapiProcTableColumnName === 'tblPersonPEActivityDescription') {
          row.tblPEapiProcTableColumnVisible = 1
        }
      })
    }
  },
  setactivity(state, data) {
    state.labels = data.actdata.ds.data1[0]
    state.categorielist = data.actdata.ds.data0
    state.settings = data.actdata.ds.data2[0]
    state.activitySettings.firstItemCatlist = data.firstItemCatlist
    // state.activityTable = data.acttabledata

    if ($('html').hasClass('mobile')) {
      state.activitySettings.hasMobile = true
    }
    // All-categories bovenaan in lijst zetten
    state.categorielist.unshift({
      categoryname: data.firstItemCatlist,
      tblProfGroupCategoryID: null,
    })
    state.activitySettings.dateToday = util.jsDateToStringDate(Date.now())
    let lstore = locStore.namespace('SPE021PEActiviteiten')
    // Als de enddate in de localstore staat, dan deze gebruiken anders vanuit de api
    if (lstore.session('enddate') !== null) {
      state.activitySettings.zoekDatumTot = new Date(lstore.session('enddate'))
      state.activitySettings.ienddate = new Date(lstore.session('enddate'))
    } else {
      state.activitySettings.zoekDatumTot = new Date(state.settings.enddate)
      state.activitySettings.ienddate = new Date(state.settings.enddate)
    }
    // Als de startdate in de localstore staat, dan deze gebruiken anders vanuit de api
    if (lstore.session('startdate') !== null) {
      state.activitySettings.zoekDatumVan = new Date(lstore.session('startdate'))
      state.activitySettings.istartdate = new Date(lstore.session('startdate'))
    } else {
      state.activitySettings.zoekDatumVan = new Date(state.settings.startdate)
      state.activitySettings.istartdate = new Date(state.settings.startdate)
    }

    // Als de categories in de localstore staat, dan deze gebruiken anders vanuit de api
    if (lstore.session('categories') !== null) {
      state.activitySettings.multiselected = lstore.session('categories')
      state.activitySettings.multiselectedfilter = lstore.session('categories')
      state.activitySettings.btnwis = true
    } else {
      // PE-23876 alleen multi select vullen met "alle categorieen" als deze nog niet gevuld is.
      if (state.activitySettings.multiselected.length === 0) {
        state.activitySettings.multiselected.push(state.categorielist[0])
        state.activitySettings.multiselectedfilter.push(state.categorielist[0])
      }
    }
    if (lstore.session('omschrijving') !== null) {
      state.activitySettings.tbxOmschrijving = lstore.session('omschrijving')
      state.activitySettings.zoekTbxOmschrijving = lstore.session('omschrijving')
      state.activitySettings.btnwis = true
    } else {
      state.activitySettings.tbxOmschrijving = ''
      state.activitySettings.zoekTbxOmschrijving = ''
    }

    if (data.role !== 'beheer' && state.settings.intSettingDialog !== 3) {
      state.activitySettings.btnToevoegenSetting = !state.activitySettings.btnToevoegenSetting
    }

    if (data.role === 'beheer' && state.settings.btnToevoegenSetting === 1) {
      state.activitySettings.btnToevoegenSetting = !state.activitySettings.btnToevoegenSetting
    }
    // })

    // Als redirect gevuld is voor beheerder dan melding geven want geen rechten
    if (data.role === 'beheer' && state.settings.redirect.length > 0) {
      window.location = state.settings.redirect
    }
  },
  setActivitySetting(state, activitySettings) {
    state.activitySettings = {
      ...state.activitySettings,
      ...activitySettings,
    }
  },
  setActivityTableData(state, data) {
    state.activityTable.tabledata = data.tabledata
  },
  // XVTABLE INSTELLINGEN BEHEER
  setXVtablesettingBeheer(state) {
    state.activityTable.tablesetting = {
      alwaysShowDetail: null,
      tableName: 'personActivities',
      paging: 1,
      pagingSize: 50,
      procedure: 'PEapi_SPE021_BH_PEActiviteiten_XVTable',
      sequence: 1,
      sortable: 1,
    }
  },
  setXVtableColumnsettingsBeheer(state) {
    state.activityTable.tablecolumnsetting = [
      {
        procedure: 'PEapi_SPE021_BH_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'tblPersonPEActivityCheckbox',
        sequence: 1,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: 14463,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'bit',
        sortColumn: null,
        widthXS: '55px',
        widthSM: '55px',
        widthMD: '55px',
        helpTextID: null,
        columnname: store.getters.translation(14463),
      },
      {
        procedure: 'PEapi_SPE021_BH_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'tblPersonActivityDateCompleted',
        sequence: 2,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 53,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'date',
        sortColumn: null,
        widthXS: '90px',
        widthSM: '90px',
        widthMD: '100px',
        helpTextID: null,
        columnname: store.getters.translation(53),
      },
      {
        procedure: 'PEapi_SPE021_BH_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'categoryname',
        sequence: 3,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 165,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: store.getters.translation(165),
      },
      {
        procedure: 'PEapi_SPE021_BH_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'tblPersonPEActivityDescription',
        sequence: 4,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 20432,
        visibleXS: 0,
        visibleSM: 1,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: store.getters.translation(20432)
      },
      {
        procedure: 'PEapi_SPE021_BH_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'tblPersonPEActivityPEPoints',
        sequence: 5,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 96,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'decimal',
        sortColumn: 'TblPersonPEActivityCalcPoints',
        widthXS: null,
        widthSM: null,
        widthMD: '155px',
        helpTextID: null,
        columnname: store.getters.translation(96),
      },
      {
        procedure: 'PEapi_SPE021_BH_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'statustxt',
        sequence: 6,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 2267,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: '150px',
        helpTextID: null,
        columnname: store.getters.translation(2267),
      },
      {
        procedure: 'PEapi_SPE021_BH_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'statusLink',
        sequence: 7,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: null,
        visibleXS: null,
        visibleSM: null,
        visibleMD: null,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Text not defined',
      },
      {
        procedure: 'PEapi_SPE021_BH_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'tblPersonActivityIDLink',
        sequence: 7,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: null,
        visibleXS: null,
        visibleSM: null,
        visibleMD: null,
        type: 'number',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Text not defined',
      },
      {
        procedure: 'PEapi_SPE021_BH_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'tblPersonActivityID',
        sequence: 9,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: null,
        visibleXS: null,
        visibleSM: null,
        visibleMD: null,
        type: 'number',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Text not defined',
      },
    ]
  },
  // XVTABLE INSTELLINGEN PROF
  setXVtablesetting(state) {
    state.activityTable.tablesetting = {
      AlwaysShowDetail: null,
      tableName: 'personActivities',
      paging: 1,
      pagingSize: 50,
      procedure: 'PEapi_SPE021_PR_PEActiviteiten_XVTable',
      sequence: 1,
      sortable: 1,
    }
  },
  setXVtableColumnsettings(state) {
    state.activityTable.tablecolumnsetting = [
      {
        procedure: 'PEapi_SPE021_PR_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'tblPersonPEActivityCheckbox',
        sequence: 1,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: 14463,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'bit',
        sortColumn: null,
        widthXS: '55px',
        widthSM: '55px',
        widthMD: '55px',
        helpTextID: null,
        columnname: store.getters.translation(14463),
      },
      {
        procedure: 'PEapi_SPE021_PR_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'tblPersonActivityDateCompleted',
        sequence: 2,
        sortable: 1,
        sortableDefault: 2,
        visible: 1,
        headerTextID: 53,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'date',
        sortColumn: null,
        widthXS: '90px',
        widthSM: '90px',
        widthMD: '100px',
        helpTextID: null,
        columnname: store.getters.translation(53),
      },
      {
        procedure: 'PEapi_SPE021_PR_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'categoryname',
        sequence: 3,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 165,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: '250px',
        helpTextID: null,
        columnname: store.getters.translation(165),
      },
      {
        procedure: 'PEapi_SPE021_PR_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'tblPersonPEActivityDescription',
        sequence: 4,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 20432,
        visibleXS: 0,
        visibleSM: 1,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: store.getters.translation(20432)
      },
      {
        procedure: 'PEapi_SPE021_PR_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'tblPersonPEActivityPEPoints',
        sequence: 5,
        sortable: 1,
        sortableDefault: 0,
        visible: 0,
        headerTextID: 96,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'decimal',
        sortColumn: 'tblPersonPEActivityCalcPoints',
        widthXS: null,
        widthSM: null,
        widthMD: '155px',
        helpTextID: null,
        columnname: store.getters.translation(96),
      },
      {
        procedure: 'PEapi_SPE021_PR_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'statustxt',
        sequence: 6,
        sortable: 1,
        sortableDefault: 0,
        visible: 0,
        headerTextID: 2267,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: '150px',
        helpTextID: null,
        columnname: store.getters.translation(2267),
      },
      {
        procedure: 'PEapi_SPE021_PR_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'statusLink',
        sequence: 7,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: null,
        visibleXS: null,
        visibleSM: null,
        visibleMD: null,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Text not defined',
      },
      {
        procedure: 'PEapi_SPE021_PR_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'tblPersonActivityIDLink',
        sequence: 7,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: null,
        visibleXS: null,
        visibleSM: null,
        visibleMD: null,
        type: 'number',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Text not defined',
      },
      {
        procedure: 'PEapi_SPE021_PR_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'trclass',
        sequence: 8,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: null,
        visibleXS: null,
        visibleSM: null,
        visibleMD: null,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Text not defined',
      },
      {
        procedure: 'PEapi_SPE021_PR_PEActiviteiten_XVTable',
        tableName: 'personActivities',
        name: 'tblPersonActivityID',
        sequence: 9,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: null,
        visibleXS: null,
        visibleSM: null,
        visibleMD: null,
        type: 'number',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Text not defined',
      },
    ]
  },
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
